<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-10 padding-right-5px">
      <div class="card my-profile-form margin-top-15px top-link">
        <div class="card-header wh-header padding-bottom-6px">
          <div class="row">
            <div class="col-md-3">
              Customer Orders
            </div>
            <div class="col-md-9 padding-right-0px">
              <div class="row">
                <div class=" offset-md-6 col-md-3 col-sm-3 padding-right padding-left-0px">
                  <div class="form-group  margin-bottom-5px">
                    <div class="row">
                      <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                        <a title="Previous" class="nav-link-hand">
                          <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                        </a>
                      </div>

                      <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

        <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
      </div>-->

                      <div class="col-md-8 col-sm-4 padding-l-0px padding-right-9px">
                        <div class="date-form">
                          <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                                 (ngModelChange)="dataChanged($event)">

                          <a (click)="d.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>



                      </div>
                      <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                        <a title="Next" class="nav-link-hand">
                          <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                        </a>
                      </div>
                      
                    </div>

                  </div>
                </div> 
                <div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px margin-left-0px">

          <div class="row">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-top-4px padding-bottom-4px">
                          #
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <!--<th class="text-align-center">
    Old Reg No
  </th>-->
                        <th class="padding-top-4px padding-bottom-4px">
                          Customer
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->
                        <th class="padding-top-4px padding-bottom-4px">
                          Mobile
                        </th>

                        <!--<th class="">
    Prime Relation
  </th>-->

                        <th class="padding-top-4px padding-bottom-4px">
                          Location
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Number of Items
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Bill Total
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Bill No
                        </th>

                        <th class="padding-top-4px padding-bottom-4px">
                          Status
                        </th>




                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr>

                        <td class="td-padding-tb"> 1 </td>
                        <!--<td class="td-padding text-align-center">Mon</td>-->
                        <!--<td class="td-padding text-align-center">

    {{l.PatientRegistrationNumber}}
  </td>-->
                        <td class=" td-padding-tb">Piyali Sarkar</td>

                        <!--<td class="td-padding text-align-center"></td>-->
                        <td class=" td-padding-tb">8106220988</td>
                        <!--<td class=" td-padding-tb ">{{l.PrimeRelation}}</td>-->

                        <td class="td-padding-tb">Hyderabad</td>
                       
                        <td class="td-padding-tb padding-right-0px text-align-center">1</td>
                        <td class="td-padding-tb  text-align-center ">100</td>
                        <td class="td-padding-tb  text-align-center ">1</td>
                        <td class="td-padding-tb "></td>


                        <!--<td class="td-padding-tb">
    <div class="row">
      <a (click)="edit_(l)" class="nav-link-hand education-navlink" title="edit">
        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
      </a>
      <a (click)="del_(l.EducationCode)" class="nav-link-hand education-navlink" title="Remove">
        <span class="badge">
          <i class="far fa-trash-alt"></i>
        </span>
      </a>

    </div>
  </td>-->



                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 padding-left-5px padding-top-15px background-dashboard">
      <div class="card    top-link height-100pe card-background-transparent">
        <div class="card-body padding-top-0px margin-left-0px">

          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">Order Details</label>
            </div>
            <div class="col-md-12">
              <h4 class="font-size-16px color-Assign">#12344</h4>
            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">From</label>
            </div>
            <div class="col-md-12">
              <h4 class="font-size-16px color-Assign margin-bottom-0px">Piyali Sarkar</h4>
            </div>
            <div class="col-md-12">
              <h4 class="font-size-13px margin-bottom-0px">8106220988</h4>
            </div>
            <div class="col-md-12">
              <h4 class="font-size-13px margin-bottom-0px">Hyderbad</h4>
            </div>
          </div>
          <div class="row row-height-17px font-weight-700 ">
            <div class="col-md-7 text-align-right">
              <label class="font-size-12px font-weight-normal margin-bottom-0px">Number of Items</label>
            </div>:
            <div class="col-md-4 font-size-12px margin-top-3px font-weight-normal">
              <label class="font-size-14 font-weight-normal margin-bottom-0px">1</label>

            </div>
          </div>
          <div class="row font-weight-700 border-bottom-1px">
            <div class="col-md-7 text-align-right">
              <label class="font-size-12px font-weight-normal margin-bottom-0px">Bill Total</label>
            </div>:
            <div class="col-md-4 font-size-12px margin-top-3px font-weight-normal">
              <label class="font-size-14 font-weight-normal margin-bottom-0px">100</label>

            </div>
          </div>
          <div class="row  border-bottom-1px">
            <div class="col-md-12">
              <label class="margin-bottom-0px font-size-12px">Status</label>
            </div>
            <div class="col-md-12 padding-bottom-3px">
              <button class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="Payment()">Received Now</button>
            </div>
          </div>
          <div class="row margin-top-5px padding-left-10px">
            <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="ViewOrder()">Open Order</button>

          </div>
          <div class="row margin-top-5px padding-left-10px">
            <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="ViewOrder()">Generate Bill</button>

          </div>
          <div class="row margin-top-5px padding-left-10px">
            <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="Payment()">Update Status</button>

          </div>
          <div class="row margin-top-5px">
            <a (click)="AddNewPatient()" class="nav-link-hand color-delete-icon padding-left-15px" title="Click here Remove Order"><i class="fas fa-times font-size-11 margin-right-3px"></i>Remove Order</a>
          </div>
          <div class="row margin-top-5px">
            <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link  margin-bottom-8px padding-left-15px" title="Click here for New Registration">Accept</a>
          </div>
        </div>

      </div>
      
    </div>
  </div>
 

</div>


